const SHIMMER_CLASS =
  "bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse";

const FileDetailsDrawerShimmer = () => {
  return (
    <div className="flex flex-col h-full">
      {/* Header */}
      <div className="flex items-center justify-between px-6 py-3 bg-hover-effect dark:bg-hover-effect-dk shrink-0">
        <div className={`h-5 w-[120px] ${SHIMMER_CLASS}`} />
        <div className={`w-[15px] h-[15px] rounded-full ${SHIMMER_CLASS}`} />
      </div>

      {/* Content */}
      <div className="flex-1 min-h-0 overflow-hidden pt-3">
        <div className="flex flex-col gap-4">
          {/* Breadcrumbs */}
          <div className="flex items-center gap-1 py-1 px-6">
            <div className={`h-3 w-[40px] ${SHIMMER_CLASS}`} />
            <div className={`h-3 w-[8px] ${SHIMMER_CLASS}`} />
            <div className={`h-3 w-[120px] ${SHIMMER_CLASS}`} />
          </div>

          {/* File name + edit icon */}
          <div className="flex items-center gap-1.5 px-6">
            <div className={`h-4 w-[200px] ${SHIMMER_CLASS}`} />
            <div className={`w-4 h-4 ${SHIMMER_CLASS}`} />
          </div>

          {/* Preview area */}
          <div className="px-6">
            <div className={`w-full h-[140px] rounded-lg ${SHIMMER_CLASS}`} />
          </div>

          {/* Collapsible sections */}
          {[0, 1, 2].map((index) => (
            <div
              key={index}
              className="mx-6 border-b border-border-gray dark:border-border-gray-dk"
            >
              <div className="flex items-center gap-1.5 py-4">
                <div className={`w-2.5 h-2.5 ml-1.5 ${SHIMMER_CLASS}`} />
                <div
                  className={`h-4 ${SHIMMER_CLASS}`}
                  style={{ width: index === 0 ? 140 : index === 1 ? 100 : 70 }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="flex items-center gap-5 px-6 py-2.5 bg-hover-effect dark:bg-hover-effect-dk shrink-0">
        <div className={`h-[26px] w-[120px] rounded-md ${SHIMMER_CLASS}`} />
        <div className={`h-[26px] w-[60px] rounded-md ${SHIMMER_CLASS}`} />
      </div>
    </div>
  );
};

export default FileDetailsDrawerShimmer;
